import { nextTick } from 'vue'
import scrollToElementIfNeeded from '~utils/scroll-to-element-if-needed'

export default function scrollToFirstInvalidField(scope = ''): void {
  nextTick().then(() => {
    const firstInvalidElement = document.querySelector(`${scope} .is-error`)
    scrollToElementIfNeeded(firstInvalidElement)
  })
}
